import { Route, RouteObject } from 'react-router-dom';
import { SystemAdminLanding } from './components/SystemAdminLanding';


export interface SystemAdminRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SystemAdminRoutes[];
}

export const systemAdminRoutes: SystemAdminRoutes[] = [
  {
    path: "/onboarding/system-admin/dashboard",
    element: <SystemAdminLanding />,
  },
]
